import React from 'react';
import { useDataValue } from 'globals/contexts/dataContext';

import { Link, generatePath } from 'react-router-dom';
import routes from 'globals/routes';

import './aboutNews.css';
import './aboutNewsMobile.css';

const AboutNews = ({content: pageContent}) => {
  const [{content, currentLanguage}, dispatch] = useDataValue();
  const logoUrl = content['logo'];
  return <section className="news" id="news">
    <div className="backgroundLayer" />
    <div className="photo">
      <img src={pageContent['image']} />
    </div>
    <div className="title" dangerouslySetInnerHTML={{
      __html: pageContent['title']
    }} />
    <div className="textContent">
    <div className="atriclesHeader">{pageContent['listtitle']}</div>
      <div className="articles">
        {pageContent['articles'].map((article, idx) => {
          return <a href={article['url']} key={idx} target="_blank" className="article">
            <div className="name">{article['name']}</div>
            <div className="brief">{article['time']}</div>
          </a>
        })}
      </div>
    </div>
</section>
}

export default AboutNews;